import React, { FC } from 'react';
import Prefix from '../SeriesDetail/ExerciseList/Prefix';
import { StyledDescription, StyledHeader, StyledTitle, TitleDescriptionWrapper } from './Atoms';
import { BlockWithNotes } from 'src/config/api/models/Block';
import { ExerciseTitleBarScoreInfo } from './ExerciseTitleBarScoreInfo';
import { Exercise } from 'src/config/api/models/Exercise';
import { useTranslation } from 'react-i18next';

type ExerciseTitleBarHeaderProps = {
  exercise: Exercise | BlockWithNotes;
  groupAverageScore?: string;
  hideTitlePrefix?: boolean;
  index?: number;
  isMobile: boolean;
  userLastScore?: string;
  expanded: string | boolean;
};

const ExerciseTitleBarHeader: FC<ExerciseTitleBarHeaderProps> = ({
  index,
  isMobile,
  exercise,
  hideTitlePrefix = false,
  userLastScore,
  groupAverageScore,
  expanded,
}) => {
  const { t } = useTranslation();
  const showDescription = expanded === `exercise_${exercise.id}` || expanded === 'all';

  return (
    <StyledHeader>
      {!hideTitlePrefix && (
        <Prefix>
          {t('trajectory.sections.shared.exercise')}
          {index !== undefined && ` ${index + 1}`}
        </Prefix>
      )}
      <TitleDescriptionWrapper>
        <StyledTitle>{exercise.title}</StyledTitle>
        {exercise.description && showDescription && exercise.type !== 'text_exercise' && (
          <StyledDescription dangerouslySetInnerHTML={{ __html: exercise.description }} />
        )}
      </TitleDescriptionWrapper>
      {isMobile && (
        <ExerciseTitleBarScoreInfo
          userLastScore={userLastScore}
          groupAverageScore={groupAverageScore}
        />
      )}
    </StyledHeader>
  );
};

export default ExerciseTitleBarHeader;
